import { getTagData } from "api/tags";
import Gauge from "components/charts/Gauge/Gauge";
import Area from "components/charts/Area/Area";
import areaApiConfig from "config/charts/areaApiConfig";
import { useEffect, useState } from "react";
import { Item } from "types/common";
import Card from "../shared/Card/Card";
import StaticDashboardContainer from "../shared/StaticDashboardContainer";
import { getExpressionById } from "api/expression";
import { getExpressionData } from "api/expression";
import { SmallestLoader, SmallLoader } from "components/shared/Loader";

const GeneralOverview = () => {
  const [randomTag, setRandomTag] = useState<Item | null>(null);
  const [asasGaugeData, setAsaasGaugeData] = useState<any>([]);
  const tableData = [
    { source: "Elastic", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
    { source: "SCADA", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
    { source: "DCIM", system: "Lorem Ipsum", message: "Lorem Ipsum", date: "Lorem Ipsum" },
  ];

  const getSingleTag = async () => {
    const randomTagData = await getTagData([244]);
    setRandomTag(randomTagData.data[0]);
  };

  useEffect(() => {
    getSingleTag();

    const fetchExp = async () => {
      const expressions = await getExpressionData([46, 47, 48, 49]);
      if (expressions.status === 200) {
        setAsaasGaugeData(expressions.data);
      }
    };

    fetchExp();
  }, []);

  return (
    <StaticDashboardContainer heading="System Availability & Reliability">
      {/* Left Panel */}
      <div className="flex gap-2 w-full h-full">
        <div className="flex-1 h-full max-h-full w-[50%] flex flex-col gap-2 min-h-0 overflow-hidden">
          <h2 className="font-semibold text-sm 2xl:text-2xl p-2 bg-darkerBlack w-full rounded-md h-min text-center">Availability</h2>

          <div className="w-full flex flex-1 flex-col gap-2 min-h-0 overflow-hidden">
            {/* First Row */}
            <div className="flex gap-2 w-full min-h-0" style={{ flex: 1 }}>
              <Card title="Availability">
                <p className="text-3xl 2xl:text-4xl text-green">99.3%</p>
              </Card>

              <Card title="Alarm response time">
                <div>
                  <p className="text-lg 2xl:text-3xl text-green">0:05:56</p>
                  <p className="text-sm 2xl:text-lg">H : M : S</p>
                </div>
              </Card>

              <Card title="System Alarms">
                <div className="p-2 flex flex-col justify-end items-end">
                  <p className="text-green">SCADA: 0</p>
                  <p className="text-red">DCIM: 2</p>
                  <p className="text-red">ELASTIC: 2</p>
                </div>
              </Card>
            </div>

            {/* Second Row */}
            <div className="w-full flex gap-2 min-h-0" style={{ flex: 1.4 }}>
              <Card title="Reliability(Upstream)">
                <div className="p-2 flex h-full">
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <div className="h-[25%]">
                      <p className="text-sm 2xl:text-2xl">MTBF</p>
                    </div>
                    <div className="h-[50%]">
                      <p className="text-lg 2xl:text-3xl text-green">0:05:56</p>
                      <p className="text-sm 2xl:text-lg">H : M : S</p>
                    </div>
                    <div className="h-[25%]">
                      <p className="text-[10px] 2xl:text-xs font-normal">Mean time between failures</p>
                    </div>
                  </div>
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <div className="h-[25%]">
                      <p className="text-sm 2xl:text-2xl">MTTR</p>
                    </div>
                    <div className="h-[50%]">
                      <p className="text-lg 2xl:text-3xl text-red">0:05:56</p>
                      <p className="text-sm 2xl:text-lg">H : M : S</p>
                    </div>
                    <div className="h-[25%] flex items-center justify-center">
                      <p className="text-[10px] 2xl:text-xs font-normal">Mean time to repair</p>
                    </div>
                  </div>
                </div>
              </Card>

              <Card title="Reliability(Downstream)">
                <div className="p-2 flex h-full">
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <div className="h-[25%]">
                      <p className="text-sm 2xl:text-2xl">MTBF</p>
                    </div>
                    <div className="h-[50%]">
                      <p className="text-lg 2xl:text-3xl text-green">0:05:56</p>
                      <p className="text-sm 2xl:text-lg">H : M : S</p>
                    </div>
                    <div className="h-[25%]">
                      <p className="text-[10px] 2xl:text-xs font-normal">Mean time between failures</p>
                    </div>
                  </div>
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <div className="h-[25%]">
                      <p className="text-sm 2xl:text-2xl">MTTR</p>
                    </div>
                    <div className="h-[50%]">
                      <p className="text-lg 2xl:text-3xl text-red">0:05:56</p>
                      <p className="text-sm 2xl:text-lg">H : M : S</p>
                    </div>
                    <div className="h-[25%] flex items-center justify-center">
                      <p className="text-[10px] 2xl:text-xs font-normal">Mean time to repair</p>
                    </div>
                  </div>
                </div>
              </Card>

              <Card title="Cooling Efficiency">
                <div className="p-2 flex h-full">
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <p className="text-sm 2xl:text-2xl h-[25%]">CER</p>
                    <p className="text-3xl 2xl:text-4xl h-[50%] text-yellow flex items-center justify-center">78%</p>
                    <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Cooling Efficiency Ratio</p>
                  </div>
                  <div className="w-full flex-1 flex flex-col justify-between">
                    <p className="text-sm 2xl:text-2xl h-[25%]">CCU</p>
                    <p className="text-3xl 2xl:text-4xl h-[50%] text-green flex items-center justify-center">56%</p>
                    <p className="text-[10px] 2xl:text-xs font-normal h-[25%] flex justify-center items-center">Cooling capacity utilization</p>
                  </div>
                </div>
              </Card>
            </div>

            {/* Table */}
            <div className="bg-black rounded-lg overflow-hidden shadow-md w-full flex flex-col justify-between min-h-0" style={{ flex: 1.6 }}>
              <div className="overflow-y-auto flex-1">
                <table className="w-full text-left text-sm text-white">
                  <thead className="bg-darkBlack text-gray-200 sticky top-0">
                    <tr className="text-sm 2xl:text-lg">
                      <th className="px-4 py-2 2xl:py-3">Data source</th>
                      <th className="px-4 py-2 2xl:py-3">System</th>
                      <th className="px-4 py-2 2xl:py-3">Alarms Message</th>
                      <th className="px-4 py-2 2xl:py-3">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, idx) => (
                      <tr key={idx} className={idx % 2 === 0 ? "bg-gray-800" : ""}>
                        <td className="px-4 py-2 2xl:py-3">{row.source}</td>
                        <td className="px-4 py-2 2xl:py-3">{row.system}</td>
                        <td className="px-4 py-2 2xl:py-3">{row.message}</td>
                        <td className="px-4 py-2 2xl:py-3">{row.date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end p-1 2xl:p-3 h-min bg-darkBlack">
                <button className="px-4 py-1 text-sm rounded-md bg-green text-white hover:bg-green/80 transition">
                  See All
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="flex-1 h-full w-[50%] max-h-full flex flex-col gap-2 min-h-0 overflow-hidden">
          <h2 className="font-semibold text-sm 2xl:text-2xl p-2 bg-darkerBlack w-full rounded-md h-min text-center">Power Utilization & Infrastructure Efficiency</h2>

          <div className="w-full flex flex-1 flex-col gap-2 max-h-full min-h-0 overflow-hidden">
            {/* First Row */}
            <div className="flex gap-2 w-full min-h-0" style={{ flex: 1 }}>
              <Card title="ITLU">
                <div className="p-2 h-full w-full">
                  <div className="text-3xl 2xl:text-4xl text-green h-[70%]">99.3%</div>
                  <p className="text-[10px] 2xl:text-xs font-normal h-[30%] flex items-center justify-center">IT Load Utilization</p>
                </div>
              </Card>

              <Card title="DCIE">
                <div className="p-2 h-full w-full">
                  <div className="text-3xl 2xl:text-4xl text-green h-[70%]">89.3%</div>
                  <p className="text-[10px] 2xl:text-[10px] 2xl:text-xs font-normal h-[30%] flex items-center justify-center">Data Centers Infrastructure</p>
                </div>
              </Card>

              <Card title="OCU">
                <div className="p-2 h-full w-full">
                  <div className="text-3xl 2xl:text-4xl text-green h-[70%]">96.3%</div>
                  <p className="text-[10px] 2xl:text-xs font-normal h-[30%] flex items-center justify-center">Operational capacity unit</p>
                </div>
              </Card>

              <Card title="PUE">
                <div className="p-2 h-full w-full">
                  <div className="flex gap-2 h-[70%]">
                    <div className="w-full">
                      <p className="text-[10px] 2xl:text-xs">Average</p>
                      <p className="text-2xl 2xl:text-3xl text-green">1.63</p>
                    </div>
                    <div className="w-full">
                      <p className="text-[10px] 2xl:text-xs">Current</p>
                      <p className="text-2xl 2xl:text-3xl text-yellow">1.72</p>
                    </div>
                  </div>
                  <p className="text-[10px] 2xl:text-xs font-normal h-[30%] flex items-center justify-center">Power Usage Effectiveness</p>
                </div>
              </Card>
            </div>

            {/* Second Row */}
            <div className="flex gap-2 w-full max-w-full max-h-full min-h-0" style={{ flex: 1.4 }}>
              <Card title="ASAS-1" className="w-[50%]">
                <div className="flex max-h-[18vh] 2xl:max-h-[19vh] min-h-0 w-full h-full">
                  <div className="h-full w-[50%]">
                    {asasGaugeData ?
                      <Gauge
                        data={{ ...asasGaugeData[0], name: 'Power Load' }}
                        gaugeType={"regular"}
                      /> :
                      <div className="flex w-full h-full items-center justify-center">
                        <SmallLoader />
                      </div>
                    }
                  </div>
                  <div className="h-full w-[50%]">
                    {asasGaugeData ?
                      <Gauge
                        data={{ ...asasGaugeData[1], name: 'Power Buffer' }}
                        gaugeType={"regular"}
                      /> :
                      <div className="flex w-full h-full items-center justify-center">
                        <SmallLoader />
                      </div>
                    }
                  </div>
                </div>
              </Card>
              <Card title="ASAS-2" className="w-[50%]">
                <div className="flex max-h-[18vh] 2xl:max-h-[19vh] min-h-0 w-full h-full">
                  <div className="h-full w-[50%]">
                    {asasGaugeData ?
                      <Gauge
                        data={{ ...asasGaugeData[2], name: 'Power Load' }}
                        gaugeType={"regular"}
                      /> :
                      <div className="flex w-full h-full items-center justify-center">
                        <SmallLoader />
                      </div>
                    }
                  </div>
                  <div className="h-full w-[50%]">
                    {asasGaugeData ?
                      <Gauge
                        data={{ ...asasGaugeData[3], name: 'Power Buffer' }}
                        gaugeType={"regular"}
                      /> :
                      <div className="flex w-full h-full items-center justify-center">
                        <SmallLoader />
                      </div>
                    }
                  </div>
                </div>
              </Card>
            </div>


            {/* Third Row */}
            {randomTag && (
              <div className="min-h-0" style={{ flex: 1.6 }}>
                <Card title="Power Buffer, KW" className="h-full">
                  <Area
                    item={randomTag}
                    type="tag"
                    areaType="regular"
                    renderType="lazyLoading"
                    maintainAspectRatio={false}
                    areaApiConfig={areaApiConfig}
                  />
                </Card>
              </div>
            )}
          </div>
        </div>
      </div>
    </StaticDashboardContainer>
  );
};

export default GeneralOverview;